import ApiClient from "~/admin/services/ApiClient";

export default class UsersApi {
  static get = (userId) => ApiClient.get(`users/${userId}`);
  static block = (userId) => ApiClient.patch(`users/block/${userId}`);
  static unblock = (userId) => ApiClient.patch(`users/unblock/${userId}`);
  static paginateBlocked = () => ApiClient.get("users/paginate-blocked");
}
